const init = () => {
    primaryNavigation();
    weglotMobileNav();
}

const primaryNavigation = () => {
    const headerEl = document.querySelector('.site-header');
    const sectionEls = document.querySelectorAll('.mega-menu .mega-menu__submenu');
    const navLinks = document.querySelectorAll('.is-style-primary-nav .wp-block-navigation-item__content');

    const showSection = ( section ) => {
        sectionEls.forEach( el => el.classList.remove('active' ) );

        const targetEl = document.querySelector(`.primary-navigation__mega-menu .mega-menu__submenu.${section}`);

        if ( !targetEl) {
            return;
        }

        targetEl.classList.add('active');

        return targetEl;
    }

    const hide = () => {
        navLinks.forEach( el => el.classList.remove('active') )
        sectionEls.forEach( el => el.classList.remove('active') );
    }

    navLinks.forEach( (navLink, index, array) => {
        navLink.addEventListener('mouseenter', (event) => {
            array.forEach( el => el.classList.remove('active') )
            let target = event.target.getAttribute('data-target');
            event.target.classList.add('active');
            showSection(target);
        })

        // open menu menu on down arrow key press
        navLink.addEventListener('keydown', (event) => {
            if (event.keyCode == 37) { // left arrow 
                event.preventDefault();
                // console.log('left arrow key pressed');
            } else if (event.keyCode == 38) { // up arrow 
                event.preventDefault();
                // console.log('up arrow key pressed');
            } else if (event.keyCode == 39) { // right arrow 
                event.preventDefault();
                // console.log('right arrow key pressed');
            } else if (event.keyCode == 40) { // down arrow 
                event.preventDefault();
                // console.log('down arrow key pressed');
                let target = event.target.getAttribute('data-target');
                event.target.classList.add('active');
                const sectionEl = showSection(target);

                let focusableChildren = getFocusableChildren(sectionEl);
                if ( focusableChildren.length > 0 ) {
                    // console.log('focusing on first menu item');
                    focusableChildren[0].focus();
                    // console.log('activeElement', document.activeElement);
                } 
            }
        })
    })

    // close mega menu on esc key press
    sectionEls.forEach( (section) => { 
        section.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') { // tab 
                event.preventDefault();
                // console.log('tab key pressed');
                if (event.shiftKey) {
                    focusPrevChildElement(section);
                } else {
                    focusNextChildElement(section);
                }
            }
            if (event.keyCode == 27) { // escape arrow 
                event.preventDefault();
                navLinks.forEach( el => { if ( el.classList.contains("active") ) el.focus(); });
                hide();
            }
        })
    })

    if ( headerEl ) {
        headerEl.addEventListener('mouseleave', () => {
            hide();
        })
    }
}

const weglotMobileNav = () => {
    const weglotMenu = document.querySelector('.mobile-weglot-menu');

    if ( !weglotMenu ) {
        return;
    }

    const current = weglotMenu.querySelector('span.wgcurrent');
    const buttonText = weglotMenu.querySelector('.wp-block-rb-snaplogic-collapsible-item__trigger-text');
    buttonText.innerHTML = current.innerHTML;
    buttonText.classList.add('weglot-globe');
}

const getFocusableChildren = (selector) => {
    const focusableChildren = selector.querySelectorAll('button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])');
    return focusableChildren;
}

const focusPrevChildElement = (selector) => {
    if (document.activeElement) {
        var focusable = Array.prototype.filter.call(
            getFocusableChildren(selector),
            function (element) {
                //check for visibility while always include the current activeElement
                return (
                    element.offsetWidth > 0 ||
                    element.offsetHeight > 0 ||
                    element === document.activeElement
                );
            }
        );
        var index = focusable.indexOf(document.activeElement);
        if (index > -1) {
            var prevElement = focusable[index - 1] || focusable[(focusable.length - 1)];
            prevElement.focus();
        }
    }
}

const focusNextChildElement = (selector) => {
    if (document.activeElement) {
        var focusable = Array.prototype.filter.call(
            getFocusableChildren(selector),
            function (element) {
                //check for visibility while always include the current activeElement
                return (
                    element.offsetWidth > 0 ||
                    element.offsetHeight > 0 ||
                    element === document.activeElement
                );
            }
        );
        var index = focusable.indexOf(document.activeElement);
        if (index > -1) {
            var nextElement = focusable[index + 1] || focusable[0];
            nextElement.focus();
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    init();
})
